export default __webpack_public_path__ + "static/carshow-mag-716f219dff27628f7dec795e4de4ed52.png";